import React, { useState } from 'react'
import styles from './ExpandableInfoCard.module.scss'

export const ExpandableInfoCard = ({
  title = 'Usage Instructions',
  instructions = [],
  initialExpanded = false
}) => {
  const [isExpanded, setIsExpanded] = useState(initialExpanded)

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className={styles.expandableInfoCard}>
      <div className={styles.expandableInfoHeader} onClick={toggleExpand}>
        <span className={styles.headerTitle}>{title}</span>
        <span
          className={styles.headerArrow}
          style={{
            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
          }}
        >
          ▼
        </span>
      </div>

      {/* The content container now has a fixed position in the document flow */}
      <div
        className={`${styles.expandableInfoContent} ${
          isExpanded ? styles.expanded : ''
        }`}
      >
        <p style={{ margin: 0 }}>
          {instructions.map((instruction, index) => (
            <React.Fragment key={index}>
              • {instruction}
              {index < instructions.length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
      </div>
    </div>
  )
}

// Example usage with player instructions:
export const PlayerInstructionsCard = () => (
  <ExpandableInfoCard
    title='Player Assignment Instructions'
    instructions={[
      'Select player to add to session',
      'Click on available tags with blue border to assign to the selected player',
      'Click on an assigned player to remove from session',
      'Press Esc to clear selection'
    ]}
  />
)

// Example usage with tag instructions:
export const TagInstructionsCard = () => (
  <ExpandableInfoCard
    title='Tag Assignment Instructions'
    instructions={[
      'Select tag to enable player selection mode',
      'Players with green border are ready for selection and will be added to session with selected tag',
      'Click on an assigned tag to remove it from session',
      'Press Esc to clear selection'
    ]}
  />
)
